import React from 'react';
import { Box, Text, HStack, ListCollection } from '@chakra-ui/react';
import BaseSelect from '../base/BaseSelect';

interface SettingSelectRowProps {
    label: string;
    value: string | undefined;
    collection: ListCollection<any>;
    onValueChange: (value: string) => void;
    placeholder?: string;
    minW?: string;
    maxW?: string;
    disabled?: boolean;
}

const SettingSelectRow: React.FC<SettingSelectRowProps> = ({
    label,
    value,
    collection,
    onValueChange,
    placeholder,
    minW = '150px',
    maxW = '200px',
    disabled = false,
}) => {
    return (
        <HStack w="full" justify="space-between" align="center" py={3} gap={4}>
            <Box flex={1} minW={0} maxW="90%">
                <Text
                    fontSize="md"
                    color={disabled ? 'gray.400' : 'black'}
                    overflow="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                >
                    {label}
                </Text>
            </Box>
            <Box flexShrink={0}>
                <BaseSelect
                    collection={collection}
                    value={value || ''}
                    onValueChange={onValueChange}
                    placeholder={placeholder}
                    minW={minW}
                    maxW={maxW}
                    disabled={disabled}
                    variant="yellow"
                />
            </Box>
        </HStack>
    );
};

export default SettingSelectRow;
